export default "__VITE_PUBLIC_ASSET__7b6352bf__"